import {useState} from 'react';
import {DemeritEducationReservationEditFormType} from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditForm';
import DemeritEducationReservationStep1Check from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationStep1Check';
import DemeritEducationReservationStep2Branch from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationStep2Branch';
import DemeritEducationReservationStep3Period from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationStep3Period';
import DemeritEducationReservationStep4Center from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationStep4Center';
import DemeritEducationReservationStep5Time from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationStep5Time';
import useUrlQueryStore from '@shared/useUrlQueryStore';

const SHARE_STEP_KEY = 's';

enum ReservationStep {
  STEP_1_CHECK, // 대상자 확인
  STEP_2_BRANCH, // 지역 선택
  STEP_3_PERIOD, // 기간 선택
  STEP_4_CENTER, // 교육장 선택
  STEP_5_TIME, // 강의시간 선택
}

export interface DemeritEducationReservationFormType {
  branchName: string;
  branchCode: string;
  educationStartDate: Date | null;
  educationEndDate: Date | null;
  centerName: string;
  centerCode: string;
  centerNotice: string;
  classroomCode: string;
  educationDate: Date | null;
  educationStartTime: Date | null;
  educationEndTime: Date | null;
}

interface DemeritEducationReservationFormProps {
  vin: string;
}

function DemeritEducationReservationForm({vin}: DemeritEducationReservationFormProps) {
  const [stepStore, setStepStore] = useUrlQueryStore<{step: ReservationStep}>(SHARE_STEP_KEY, {
    step: ReservationStep.STEP_1_CHECK,
  });

  const [form, setForm] = useState<DemeritEducationReservationFormType>({
    branchName: '',
    branchCode: '',
    educationStartDate: null,
    educationEndDate: null,
    centerName: '',
    centerCode: '',
    centerNotice: '',
    classroomCode: '',
    educationDate: null,
    educationStartTime: null,
    educationEndTime: null,
  });

  function updateForm(partial: Partial<DemeritEducationReservationFormType>) {
    setForm({...form, ...partial});
  }

  return (
    <>
      {stepStore.step === ReservationStep.STEP_1_CHECK && (
        <DemeritEducationReservationStep1Check
          vin={vin}
          onNext={() => setStepStore({step: ReservationStep.STEP_2_BRANCH})}
        />
      )}
      {stepStore.step === ReservationStep.STEP_2_BRANCH && (
        <DemeritEducationReservationStep2Branch
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
          onNext={() => setStepStore({step: ReservationStep.STEP_3_PERIOD})}
        />
      )}
      {stepStore.step === ReservationStep.STEP_3_PERIOD && (
        <DemeritEducationReservationStep3Period
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
          onNext={() => setStepStore({step: ReservationStep.STEP_4_CENTER})}
        />
      )}
      {stepStore.step === ReservationStep.STEP_4_CENTER && (
        <DemeritEducationReservationStep4Center
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
          onNext={() => setStepStore({step: ReservationStep.STEP_5_TIME})}
        />
      )}
      {stepStore.step === ReservationStep.STEP_5_TIME && (
        <DemeritEducationReservationStep5Time
          vin={vin}
          form={form}
          onUpdateForm={(partial: Partial<DemeritEducationReservationEditFormType>) => updateForm(partial)}
        />
      )}
    </>
  );
}

export default DemeritEducationReservationForm;
